/* eslint-disable spire/export-styles */
import Zone from "@insite/client-framework/Components/Zone";
import { ColumnAlignment } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridWidths } from "@insite/mobius/GridItem";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    columns = "columns",
    gap = "gap",
    cssClass = "cssClass",
    alignment = "alignment",
    reflow = "reflow",
}

interface Props extends WidgetProps {
    fields: {
        [fields.columns]: GridWidths[];
        [fields.gap]: number;
        [fields.cssClass]: string;
        [fields.alignment]: ColumnAlignment[];
        [fields.reflow]: boolean;
    };
}

const mobileColumnsRef: { [key: number]: GridWidths | GridWidths[] } = {
    1: [3, 3, 1, 1, 1],
    2: [4, 4, 2, 2, 2],
    3: [6, 6, 3, 3, 3],
    4: [6, 6, 4, 4, 4],
    5: [12, 12, 5, 5, 5],
    6: [12, 12, 6, 6, 6],
    7: [12, 12, 7, 7, 7],
    8: [12, 12, 8, 8, 8],
    9: [12, 12, 9, 9, 9],
    10: [12, 12, 10, 10, 10],
    11: [12, 12, 11, 11, 11],
    12: 12,
};

const convertToResponsive = (column: GridWidths): GridWidths | GridWidths[] => {
    return mobileColumnsRef[column] || column;
};
export interface StaticPagesStyles {
    conainer?: InjectableCss;
}
const styles: StaticPagesStyles = {
    conainer: {
        css: css`
            &.carrerPageWrapper {
                margin: 0 auto;
                padding: 66px 138px;
                background-color: #ffffff;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 50px;
                            border: none;
                        `,
                        css`
                            padding: 50px;
                            border: none;
                        `,
                        css`
                            border: none;
                        `,
                        css`
                            border: 1px solid #e1e1e1;
                        `,
                        css`
                            border: 1px solid #e1e1e1;
                        `,
                    ])}

                .career_page {
                    .career_heading {
                        font-weight: 600;
                        letter-spacing: 0;
                        line-height: 36px;
                        color: #33333a;
                        padding-bottom: 20px;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    font-size: 25px;
                                `,
                                css`
                                    font-size: 25px;
                                `,
                                css`
                                    font-size: 25px;
                                `,
                                css`
                                    font-size: 30px;
                                `,
                                css`
                                    font-size: 30px;
                                `,
                            ])}
                    }

                    .career_para {
                        color: #33333a;
                        font-weight: 300;
                        letter-spacing: 0;
                        line-height: 24px;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    font-size: 15px;
                                `,
                                css`
                                    font-size: 15px;
                                `,
                                css`
                                    font-size: 15px;
                                `,
                                css`
                                    font-size: 16px;
                                `,
                                css`
                                    font-size: 16px;
                                `,
                            ])}
                    }

                    .career_link,
                    .career_link-CustomerSupport {
                        font-size: 16px;
                        color: #006bc0;
                        font-weight: 600;
                        letter-spacing: 0;
                        line-height: 24px;
                    }

                    .career_link-CustomerSupport {
                        margin-bottom: 0;
                    }
                }
            }
            &.glpPageWrapper {
                margin: 0 auto;
                padding: 76px 138px;
                background-color: #ffffff;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 50px;
                            border: none;
                        `,
                        css`
                            padding: 50px;
                            border: none;
                        `,
                        css`
                            border: none;
                        `,
                        css`
                            border: 1px solid #e1e1e1;
                        `,
                        css`
                            border: 1px solid #e1e1e1;
                        `,
                    ])}

                .contactUs-Section {
                    padding-top: 30px;
                    &.contact {
                        > div[class^="GridOffset"] {
                            > div:first-child[class^="GridItemStyle"] {
                                > div[class^="Wrapper"] {
                                    > div:first-child {
                                        padding-bottom: 22px;
                                    }
                                    > div:nth-child(2) {
                                        ${({ theme }: { theme: BaseTheme }) =>
                                            breakpointMediaQueries(
                                                theme,
                                                [
                                                    css`
                                                        padding-bottom: 42px;
                                                    `,
                                                    css`
                                                        padding-bottom: 42px;
                                                    `,
                                                    null,
                                                    null,
                                                ],
                                                "minMax",
                                            )}
                                    }
                                }
                            }
                            > div[class^="GridItemStyle"] {
                                &:nth-child(2) {
                                    > div[class^="Wrapper"] {
                                        > div:first-child {
                                            padding-bottom: 22px;
                                            ${({ theme }: { theme: BaseTheme }) =>
                                                breakpointMediaQueries(
                                                    theme,
                                                    [
                                                        null,
                                                        null,
                                                        css`
                                                            padding-bottom: 45px;
                                                        `,
                                                        css`
                                                            padding-bottom: 45px;
                                                        `,
                                                    ],
                                                    "minMax",
                                                )}
                                        }
                                        > div:nth-child(2) {
                                            ${({ theme }: { theme: BaseTheme }) =>
                                                breakpointMediaQueries(
                                                    theme,
                                                    [
                                                        css`
                                                            padding-bottom: 35px;
                                                        `,
                                                        css`
                                                            padding-bottom: 35px;
                                                        `,
                                                        null,
                                                        null,
                                                    ],
                                                    "minMax",
                                                )}
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                #contact_us_heading {
                    color: #33333a;
                    font-weight: 600;
                    letter-spacing: 0;
                    line-height: 36px;
                    margin-bottom: 0px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                font-size: 25px;
                            `,
                            css`
                                font-size: 25px;
                            `,
                            css`
                                font-size: 25px;
                            `,
                            css`
                                font-size: 30px;
                                margin-top: -5px;
                            `,
                            css`
                                font-size: 30px;
                                margin-top: -5px;
                            `,
                        ])}
                }

                #contact_us_para {
                    color: #33333a;
                    font-weight: 300;
                    letter-spacing: 0;
                    line-height: 24px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                font-size: 15px;
                            `,
                            css`
                                font-size: 15px;
                            `,
                            css`
                                font-size: 15px;
                            `,
                            css`
                                font-size: 16px;
                            `,
                            css`
                                font-size: 16px;
                            `,
                        ])}
                }

                .regional_heading {
                    font-weight: 600;
                    letter-spacing: 0;
                    line-height: 36px;
                    color: #33333a;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                font-size: 21px;
                                padding-bottom: 5px;
                            `,
                            css`
                                font-size: 21px;
                                padding-bottom: 5px;
                            `,
                            css`
                                font-size: 30px;
                                padding-bottom: 15px;
                            `,
                            css`
                                font-size: 30px;
                                padding-bottom: 15px;
                            `,
                            css`
                                font-size: 30px;
                                padding-bottom: 15px;
                            `,
                        ])}
                }

                .ct-contact-market {
                    div[class^="GridOffset"] {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        padding-bottom: 30px;
                                    `,
                                    css`
                                        padding-bottom: 30px;
                                    `,
                                    null,
                                    null,
                                ],
                                "minMax",
                            )}
                        > div[class^="GridItemStyle"] {
                            position: relative;
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(
                                    theme,
                                    [
                                        css`
                                            margin-bottom: 30px;
                                        `,
                                        css`
                                            margin-bottom: 30px;
                                        `,
                                        css`
                                            margin-bottom: 20px;
                                        `,
                                        null,
                                    ],
                                    "minMax",
                                )}
                            > div[class^="Wrapper"] {
                                > div[id^="parent_wrapper"] {
                                    height: 100%;
                                    padding-bottom: 60px;
                                    ${({ theme }: { theme: BaseTheme }) =>
                                        breakpointMediaQueries(
                                            theme,
                                            [
                                                null,
                                                null,
                                                null,
                                                css`
                                                    padding-bottom: 70px;
                                                `,
                                            ],
                                            "minMax",
                                        )}
                                    > div[id^="wrapper"] {
                                        position: absolute;
                                        bottom: 0;
                                        padding-top: 25px;
                                    }
                                }
                            }
                        }
                        div[class^="GridItemStyle"]:last-child {
                            position: relative;
                            @media (max-width: 991px) {
                                padding-bottom: 0;
                                div[class^="Wrapper"] {
                                    > div[id="parent_wrapper"] {
                                        padding-bottom: 0;
                                        ${({ theme }: { theme: BaseTheme }) =>
                                            breakpointMediaQueries(
                                                theme,
                                                [
                                                    css`
                                                        padding-bottom: 50px;
                                                    `,
                                                    css`
                                                        padding-bottom: 50px;
                                                    `,
                                                    css`
                                                        padding-bottom: 80px;
                                                    `,
                                                    null,
                                                ],
                                                "minMax",
                                            )}
                                    }
                                }
                            }
                        }
                    }
                }

                .cs-regionalSalesTeam {
                    > div[class^="GridOffset"] {
                        > div[class^="GridItemStyle"] {
                            position: relative;
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(
                                    theme,
                                    [
                                        css`
                                            margin-bottom: 30px;
                                        `,
                                        css`
                                            margin-bottom: 30px;
                                        `,
                                        css`
                                            margin-bottom: 20px;
                                        `,
                                        null,
                                    ],
                                    "minMax",
                                )}
                            > div[class^="Wrapper"] {
                                > div[id^="parent_wrapper"] {
                                    height: 100%;
                                    padding-bottom: 50px;
                                    ${({ theme }: { theme: BaseTheme }) =>
                                        breakpointMediaQueries(
                                            theme,
                                            [
                                                null,
                                                null,
                                                null,
                                                css`
                                                    padding-bottom: 70px;
                                                `,
                                            ],
                                            "minMax",
                                        )}
                                    > div[id^="wrapper"] {
                                        position: absolute;
                                        bottom: 20px;
                                        padding-top: 25px;
                                        ${({ theme }: { theme: BaseTheme }) =>
                                            breakpointMediaQueries(
                                                theme,
                                                [
                                                    css`
                                                        bottom: 0px;
                                                    `,
                                                    css`
                                                        bottom: 0px;
                                                    `,
                                                    css`
                                                        bottom: 0px;
                                                    `,
                                                    css`
                                                        bottom: 0px;
                                                    `,
                                                ],
                                                "minMax",
                                            )}
                                    }
                                }
                            }
                        }
                    }
                }

                .regional_sales_team {
                    padding-top: 45px;
                    > div[class^="GridOffset"] {
                        > div[class^="GridItemStyle"] {
                            position: relative;
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(
                                    theme,
                                    [
                                        css`
                                            margin-bottom: 30px;
                                        `,
                                        css`
                                            margin-bottom: 30px;
                                        `,
                                        css`
                                            margin-bottom: 20px;
                                        `,
                                        null,
                                    ],
                                    "minMax",
                                )}
                            > div[class^="Wrapper"] {
                                > div[id^="parent_wrapper"] {
                                    height: 100%;
                                    padding-bottom: 60px;
                                    ${({ theme }: { theme: BaseTheme }) =>
                                        breakpointMediaQueries(
                                            theme,
                                            [
                                                null,
                                                null,
                                                css`
                                                    padding-bottom: 70px;
                                                `,
                                                null,
                                            ],
                                            "minMax",
                                        )}
                                    > div[id^="wrapper"] {
                                        position: absolute;
                                        bottom: 0;
                                        padding-top: 25px;
                                    }
                                }
                            }
                        }
                    }
                }

                .ct-RegionalSalesTeams {
                    > div[class^="GridOffset"] {
                        flex-direction: column;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        flex-direction: row;
                                    `,
                                    css`
                                        flex-direction: row;
                                    `,
                                    css`
                                        flex-direction: row;
                                    `,
                                    null,
                                ],
                                "minMax",
                            )}
                    }
                }

                #contact_us_regional_section {
                    :first-child {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                css`
                                    padding-bottom: 30px;
                                `,
                                css`
                                    padding-bottom: 30px;
                                `,
                                null,
                                null,
                                null,
                            ])}
                    }
                    .heading {
                        font-size: 16px;
                        font-weight: 600;
                        letter-spacing: 0;
                        line-height: 24px;
                        color: #33333a;
                        display: block;
                    }
                    .description {
                        font-size: 16px;
                        font-weight: 300;
                        letter-spacing: 0;
                        line-height: 24px;
                        color: #33333a;
                        display: block;
                    }
                    .phoneNumber {
                        font-size: 16px;
                        font-weight: 600;
                        letter-spacing: 0;
                        line-height: 24px;
                        color: #006bc0;
                        padding-bottom: 20px;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        padding-bottom: 0;
                                    `,
                                    css`
                                        padding-bottom: 0;
                                    `,
                                    css`
                                        padding-bottom: 0;
                                    `,
                                    null,
                                ],
                                "minMax",
                            )}
                    }
                }
                #hubspot {
                    > iframe {
                        width: 100% !important;
                    }
                }
            }

            &.privacyPolicyPageWrapper {
                margin: 0 auto;
                padding: 70px 138px 76px;
                background-color: #ffffff;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 50px;
                            border: none;
                        `,
                        css`
                            padding: 50px;
                            border: none;
                        `,
                        css`
                            border: none;
                        `,
                        css`
                            border: 1px solid #e1e1e1;
                        `,
                        css`
                            border: 1px solid #e1e1e1;
                        `,
                    ])}
                .privacyPolicyText,
                    .privacyPolicyPoints,
                    .privacyPolicyPoints-li,
                    .privacyPolicy-personalInfo,
                    .privacyPolicyText-personalInfo,
                    .privacyPolicyPoints-ways {
                    color: #33333a;
                    font-size: 16px;
                    letter-spacing: 0;
                    line-height: 24px;
                }

                .privacyPolicyPoints-ways {
                    font-weight: bold;
                    padding: 37px 0 0 0;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    padding: 37px 0 0 0;
                                `,
                                css`
                                    padding: 37px 0 0 0;
                                `,
                                null,
                                null,
                                null,
                            ],
                            "minMax",
                        )}
                }

                .privacyPolicyPoints,
                .privacyPolicy-personalInfo {
                    font-weight: bold;
                    margin-top: 45px;
                }

                .privacyPolicyPoints-ul,
                .privacyPolicyPoints-ul-info {
                    padding: 0 0 0 25px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    padding: 0 0 0 20px;
                                `,
                                css`
                                    padding: 0 0 0 20px;
                                `,
                                null,
                                null,
                                null,
                            ],
                            "minMax",
                        )}
                }

                .privacyPolicyPoints-li {
                    margin-bottom: 16px;
                    padding-left: 11px;
                }

                .privacyPolicy-personalInfo,
                .privacyPolicyText-personalInfo {
                    margin-bottom: 0;
                }

                .privacyPolicyText-personalInfo2 {
                    margin-bottom: 0;
                    padding-bottom: 15px;
                }
            }

            &.aboutUsPageWrapper {
                margin: 0 auto;
                padding: 66px 138px 55px 138px;
                background-color: #ffffff;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 50px;
                            border: none;
                        `,
                        css`
                            padding: 50px;
                            border: none;
                        `,
                        css`
                            border: none;
                        `,
                        css`
                            border: 1px solid #e1e1e1;
                        `,
                        css`
                            border: 1px solid #e1e1e1;
                        `,
                    ])}
                #about_us_culture_heading {
                    color: #33333a;
                    font-weight: 600;
                    letter-spacing: 0;
                    line-height: 36px;
                    margin-bottom: 0px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                font-size: 25px;
                            `,
                            css`
                                font-size: 25px;
                            `,
                            css`
                                font-size: 25px;
                            `,
                            css`
                                font-size: 30px;
                            `,
                            css`
                                font-size: 30px;
                            `,
                        ])}
                }

                #about_us_culture_para {
                    color: #33333a;
                    font-weight: 300;
                    letter-spacing: 0;
                    line-height: 24px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                font-size: 15px;
                                padding-right: 15px;
                            `,
                            css`
                                font-size: 15px;
                                padding-right: 15px;
                            `,
                            css`
                                font-size: 15px;
                                padding-right: 15px;
                            `,
                            css`
                                font-size: 16px;
                            `,
                            css`
                                font-size: 16px;
                            `,
                        ])}
                }

                #location_para {
                    color: #33333a;
                    font-weight: 300;
                    letter-spacing: 0;
                    line-height: 24px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                font-size: 15px;
                                padding-right: 15px;
                            `,
                            css`
                                font-size: 15px;
                                padding-right: 15px;
                            `,
                            css`
                                font-size: 15px;
                                padding-right: 15px;
                            `,
                            css`
                                font-size: 16px;
                            `,
                            css`
                                font-size: 16px;
                            `,
                        ])}
                }
            }

            &.PageNotFound {
                .title {
                    text-align: center;
                    font-size: 50px;
                    font-weight: 300;
                    letter-spacing: 0;
                    line-height: 61px;
                    color: #33333a;
                    margin-top: 65px;
                    margin-bottom: 56px;
                    max-width: 867px;
                    margin-left: auto;
                    margin-right: auto;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                font-size: 36px;
                                line-height: 43px;
                                max-width: 80%;
                            `,
                            css`
                                font-size: 36px;
                                line-height: 43px;
                                max-width: 80%;
                            `,
                            css`
                                font-size: 36px;
                                line-height: 43px;
                                max-width: 80%;
                            `,
                            null,
                            null,
                        ])}
                }
                .description {
                    color: #33333a;
                    font-size: 16px;
                    font-weight: 300;
                    letter-spacing: 0;
                    line-height: 24px;
                    margin-bottom: 82px !important;
                    max-width: 860px;
                    margin-left: auto !important;
                    margin-right: auto !important;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                max-width: 80%;
                            `,
                            css`
                                max-width: 80%;
                            `,
                            css`
                                max-width: 80%;
                            `,
                            null,
                            null,
                        ])}
                }
                padding-bottom: 72px;
            }

            &.warrantiesPageWrapper {
                margin: 0 auto;
                padding: 60px 140px;
                background-color: #ffffff;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 50px;
                            border: none;
                        `,
                        css`
                            padding: 50px;
                            border: none;
                        `,
                        css`
                            border: none;
                        `,
                        css`
                            border: 1px solid #e1e1e1;
                        `,
                        css`
                            border: 1px solid #e1e1e1;
                        `,
                    ])}

                #warranty_heading {
                    color: #33333a;
                    font-size: 21px;
                    font-weight: 600;
                    letter-spacing: 0;
                    line-height: 25px;
                    margin-bottom: 12px;
                }

                .warranty_para_class {
                    color: #33333a;
                    font-size: 16px;
                    font-weight: 300;
                    letter-spacing: 0;
                    line-height: 24px;
                }

                #warranty_2st_para {
                    font-weight: 500;
                    font-size: 16px;
                    color: #33333a;
                }

                .claims {
                    color: #33333a;
                    font-weight: 400;
                    letter-spacing: 0;
                    line-height: 25px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                font-size: 17px;
                            `,
                            css`
                                font-size: 17px;
                            `,
                            css`
                                font-size: 18px;
                            `,
                            css`
                                font-size: 18px;
                            `,
                            css`
                                font-size: 18px;
                            `,
                        ])}
                }
            }

            &.discontinuedPageWrapper {
                margin: 0 auto;
                padding: 76px 138px;
                background-color: #ffffff;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 30px 50px 0px 50px;
                            border: none;
                        `,
                        css`
                            padding: 30px 50px 0px 50px;
                            padding-top: 30px;

                            border: none;
                        `,
                        css`
                            border: none;
                        `,
                        css`
                            border: 1px solid #e1e1e1;
                        `,
                        css`
                            border: 1px solid #e1e1e1;
                        `,
                    ])}
            }
            &.policiesPageWrapper {
                margin: 0 auto;
                padding: 60px 138px 76px;
                background-color: #ffffff;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 50px;
                            border: none;
                        `,
                        css`
                            padding: 50px;
                            border: none;
                        `,
                        css`
                            border: none;
                        `,
                        css`
                            border: 1px solid #e1e1e1;
                        `,
                        css`
                            border: 1px solid #e1e1e1;
                        `,
                    ])}
            }

            &.FAQsPageWrapper {
                margin: 0 auto;
                padding: 60px 140px 76px;
                background-color: #ffffff;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 50px;
                            border: none;
                        `,
                        css`
                            padding: 50px;
                            border: none;
                        `,
                        css`
                            border: none;
                        `,
                        css`
                            border: 1px solid #e1e1e1;
                        `,
                        css`
                            border: 1px solid #e1e1e1;
                        `,
                    ])}
            }
        `,
    },
};
const INTStaticPages: React.FunctionComponent<Props> = (props: Props) => {
    const {
        fields: { columns, gap, cssClass, alignment, reflow },
        id,
    } = props;

    const columnElements: JSX.Element[] = [];

    for (let x = 0; x < columns.length; x += 1) {
        const align = alignment[x] ? alignment[x] : "top";
        columnElements.push(
            <GridItem key={x} width={reflow ? convertToResponsive(columns[x]) : columns[x]} align={align}>
                <Zone contentId={id} zoneName={`Content${x}`} />
            </GridItem>,
        );
    }

    return (
        <GridContainer className={cssClass} {...styles.conainer} gap={gap || 0}>
            {columnElements}
        </GridContainer>
    );
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const widgetModule: WidgetModule = {
    component: INTStaticPages,
    definition: {
        group: "Basic",
        icon: "Row",
        fieldDefinitions: [
            {
                name: fields.columns,
                displayName: "Layout",
                editorTemplate: "ColumnsField",
                defaultValue: [4, 4, 4],
                fieldType: "General",
                sortOrder: 1,
                validate: value => (value.length > 0 ? null : "Please enter a valid layout."),
            },
            {
                name: fields.reflow,
                displayName: "Use default reflow for responsive screens sizes",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.gap,
                displayName: "Gap Between Items",
                editorTemplate: "IntegerField",
                defaultValue: 0,
                fieldType: "General",
                max: 1000,
                min: 0,
                sortOrder: 10,
            },
            {
                name: fields.cssClass,
                displayName: "Add CSS Class",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.alignment,
                displayName: "Column Alignment",
                editorTemplate: "ColumnAlignmentField",
                defaultValue: [],
                fieldType: "General",
                sortOrder: 1,
                tab: advancedTab,
            },
        ],
    },
};

export default widgetModule;
